<template>
  <div class="page">
    <div class="cards cards-revealed cards-pickable">
      <SingleCard :card="[1,1,1,1]" msg="" />
      <SingleCard :card="[2,0,2,1]" :show-message="true" msg="yyy" />
      <SingleCard :card="[3,2,0,1]" msg="" />
      <SingleCard :card="[1,2,2,0]" :is-picked="true" />
      <SingleCard :card="[2,1,0,0]" :is-gap-filler="true" />
      <SingleCard :card="[3,0,1,0]" :is-marked-valid="true" />
      <SingleCard :card="[1,0,0,2]" :is-marked-invalid="true" />
      <SingleCard :card="[2,2,1,2]" />
      <SingleCard :card="[3,1,2,2]" />
    </div>
  </div>
</template>

<script>
import SingleCard from './components/SingleCard.vue'

export default {
  name: 'DesignSetExample',
  components: {
    SingleCard
  }
}
</script>

<style scoped>
.page {
  display: flex;

  .cards-revealed, .cards-found-sets {
    display: flex;
    max-width: 810px;
    flex-wrap: wrap;
    align-content: flex-start;
  }
  .cards-found-sets {
    width: 420px;
    align-content: flex-start;

    .card {
      width: 130px;
      height: 80px;
    }
  }
}

</style>